"use strict";

/* -----------------------------------------------
 🔁 Core Spin Logic (PURE – global / observer YOK)
--------------------------------------------------*/
function as$btn(btn) {
  if (!btn) return $();
  if (btn.jquery) return btn;
  return $(btn);
}

/* -----------------------------------------------
 ⚡ Spinner Template (tek sefer)
--------------------------------------------------*/
const SPINNER_HTML = `
<svg class="spinner" xmlns="http://www.w3.org/2000/svg"
     fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
  <circle class="opacity-25" cx="12" cy="12" r="10"
          stroke="currentColor" stroke-width="4"></circle>
  <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8V0
           C5.373 0 0 5.373 0 12h4
           zm2 5.291A7.962 7.962 0 014 12H0
           c0 3.042 1.135 5.824 3 7.938l3-2.647z">
  </path>
</svg>
`;

// Button -> spinner DOM node cache
const spinnerRef = new WeakMap();

/* -----------------------------------------------
 🧩 internal: spinner getir / oluştur
--------------------------------------------------*/
function ensureSpinner($btn, spinnerSelector) {
  const el = $btn[0];
  if (!el) return null;

  // 1) Cache hit
  const cached = spinnerRef.get(el);
  if (cached && cached.isConnected) return cached;
  if (cached && !cached.isConnected) {
    $btn.append(cached);
    return cached;
  }

  // 2) DOM içinde var mı? (dışarıdan eklenmiş olabilir)
  const found = el.querySelector?.(spinnerSelector);
  if (found) {
    spinnerRef.set(el, found);
    return found;
  }

  // 3) Yoksa oluştur (tek parse)
  const $spinner = $(SPINNER_HTML);
  $btn.append($spinner);
  const node = $spinner[0];
  spinnerRef.set(el, node);
  return node;
}

/* -----------------------------------------------
 🧩 internal: spinner'ı görünür yap (stop display:none yaptıysa geri aç)
--------------------------------------------------*/
function showSpinner(node) {
  if (!node) return;
  // stop() inline display:none yaptıysa bunu sıfırla
  if (node.style && node.style.display === "none") node.style.display = "";
  else if (node.style) node.style.display = ""; // garanti
}

/* -----------------------------------------------
 ▶️ START
--------------------------------------------------*/
export function start(btn, opts = {}) {
  const $btn = as$btn(btn);
  if (!$btn.length) return;

  const {
    loadingClass = "btn-loading",
    spinnerSelector = "svg.spinner",

    touchDisabled = true,
    disable = true,
  } = opts;

  // spinner'ı her durumda hazırla + görünür yap (loading olsa bile)
  const spinnerNode = ensureSpinner($btn, spinnerSelector);
  showSpinner(spinnerNode);

  // zaten loading ise sadece spinner görünürlüğünü garanti edip çık
  if ($btn.hasClass(loadingClass)) return;

  $btn.addClass(loadingClass);

  if (touchDisabled) {
    if (disable) $btn.prop("disabled", true).attr("aria-busy", "true");
    else $btn.prop("disabled", false).removeAttr("aria-busy");
  }
}

/* -----------------------------------------------
 ⏹️ STOP
--------------------------------------------------*/
export function stop(btn, opts = {}) {
  const $btn = as$btn(btn);
  if (!$btn.length) return;

  const {
    loadingClass = "btn-loading",
    spinnerSelector = "svg.spinner",
    removeSpinner = true,

    touchDisabled = true,
    enable = true,

    hideInsteadOfRemove = true,
  } = opts;

  // loading class yoksa bile disabled geri almak gerekebilir
  if (!$btn.hasClass(loadingClass)) {
    if (touchDisabled) {
      if (enable) $btn.prop("disabled", false).removeAttr("aria-busy");
      else $btn.prop("disabled", true).attr("aria-busy", "true");
    }
    return;
  }

  $btn.removeClass(loadingClass);

  if (removeSpinner) {
    const el = $btn[0];
    const cached = spinnerRef.get(el);

    if (cached) {
      if (hideInsteadOfRemove) cached.style.display = "none";
      else cached.remove();
    } else {
      const node = el.querySelector?.(spinnerSelector);
      if (node) {
        if (hideInsteadOfRemove) node.style.display = "none";
        else node.remove();
      }
    }
  }

  if (touchDisabled) {
    if (enable) $btn.prop("disabled", false).removeAttr("aria-busy");
    else $btn.prop("disabled", true).attr("aria-busy", "true");
  }
}

/* -----------------------------------------------
 🔁 TOGGLE
--------------------------------------------------*/
export function toggle(btn, state, opts = {}) {
  if (state) start(btn, opts);
  else stop(btn, opts);
}

/* -----------------------------------------------
 ✅ Facade: MeltdownSpin.start/stop/toggle
--------------------------------------------------*/
export const MeltdownSpin = Object.freeze({
  start,
  stop,
  toggle,
});

export default MeltdownSpin;
